import { compose, withHandlers } from 'recompose'
import { withRouter } from 'react-router-dom'
import withTranslations from '../../core/withTranslations'
import RegisterCharityConfirmation from '../../ui/views/register-charity-confirmation'

const translate = withTranslations({
  heroText: 'registerCharity.confirmation.heroText',
  subText: 'registerCharity.confirmation.subText',
  createEventText: 'registerCharity.confirmation.createEventText',
  createEventButtonLabel: 'registerCharity.confirmation.createEventButtonLabel',
  skipNowText: 'registerCharity.confirmation.skipNowText',
  goHomeButtonLabel: 'registerCharity.confirmation.goHomeButtonLabel'
})

const withButtonHandlers = withHandlers({
  onCreateEventClick: props => e => {
    e && e.preventDefault()
    props.history.replace('/mycharity/')
  }
})

const decorator = compose(withRouter, translate, withButtonHandlers)

export default decorator(RegisterCharityConfirmation)



// WEBPACK FOOTER //
// ./src/services/register-charity/Confirmation.js